/** Rutas donde no debe restaurarse sesión ni llamar /api/user, /api/menu, etc. */
const PUBLIC_AUTH_ROUTES = [
  "LoginForm",
  "TwoFactorChallenge",
  "ForgotPassword",
  "ResetPassword",
  "EnviarTicket",
];

/** Rutas permitidas aunque el usuario aún no tenga 2FA activo. */
const TWO_FACTOR_SETUP_ALLOWED_ROUTES = [
  "PerfilUsuario",
  "LoginForm",
  "TwoFactorChallenge",
  "ForgotPassword",
  "ResetPassword",
];

export function isPublicAuthRoute(routeName) {
  return PUBLIC_AUTH_ROUTES.includes(routeName);
}

export function isTwoFactorSetupAllowedRoute(routeName) {
  return TWO_FACTOR_SETUP_ALLOWED_ROUTES.includes(routeName);
}
